'use strict';

exports.__esModule = true;

var _seamlessImmutable = require('seamless-immutable');

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

var _request = require('../constants/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchRequest = function fetchRequest(state, action) {
  if (state.value) {
    return state.merge(_request.PENDING).setIn(['meta'], action.request.meta);
  }
  return (0, _seamlessImmutable2.default)(_request.PENDING).setIn(['meta'], action.request.meta);
};

exports.default = fetchRequest;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/fetchRequest.js
// module id = 150
// module chunks = 0